import './font.css';

(() => {
  if (typeof document !== 'undefined' && document.fonts) {
    setTimeout(() => {
      document.fonts.load('300 16px "Material Symbols Rounded"');
    }, 0);
  }
})();
